<template>
  <div>
    <v-card
      class="pa-2 d-flex align-center justify-space-between hoverable"
      outlined
      elevation="1"
      @click="dialogProveedor = !dialogProveedor"
      style="cursor: pointer"
    >
      <v-row no-gutters align="center" class="flex-grow-1">
        <v-col cols="auto" v-if="!proveedorSeleccionado">
          <v-icon color="grey darken-1" class="mr-2">mdi-account-search</v-icon>
        </v-col>

        <v-col>
          <div class="text-subtitle-2 font-weight-medium">
            {{
              proveedorSeleccionado
                ? proveedorSeleccionado.nombre
                : "Seleccionar proveedor"
            }}
          </div>
          <div class="text-caption grey--text" v-if="!proveedorSeleccionado">
            Hacé click para elegir
          </div>
        </v-col>

        <v-col cols="auto" v-if="proveedorSeleccionado">
          <v-btn
            icon
            small
            color="grey darken-1"
            @click.stop="quitarProveedor()"
            :ripple="false"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogProveedor" width="700">
      <v-card>
        <v-container>
          <v-card-title class="d-flex align-center">
            <span class="text-h6">Seleccionar proveedor</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogProveedor = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="search"
              dense
              outlined
              placeholder="Buscar proveedor..."
              append-icon="mdi-magnify"
              @input="onSearch"
            ></v-text-field>

            <v-row>
              <v-col
                v-for="p in proveedoresFiltered"
                :key="p.id"
                cols="6"
                sm="4"
                md="3"
              >
                <v-card
                  height="100%"
                  flat
                  class="d-flex flex-column align-center justify-center pa-2 text-center cursor-pointer"
                  :elevation="isSelected(p) ? 6 : 1"
                  :class="{
                    'border-primary': isSelected(p),
                    'hoverable-card': true,
                  }"
                  @click="sendProveedor(p)"
                >
                  <v-icon
                    v-if="isSelected(p)"
                    color="blue"
                    size="18"
                    class="mb-1"
                  >
                    mdi-check-circle
                  </v-icon>
                  <div class="text-body-2">{{ p.nombre }}</div>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="nextPage && !loading">
              <v-col>
                <div class="text-center">
                  <v-btn class="blue--text" text small @click="loadMore">
                    Cargar más
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-list-item v-if="loading">
              <v-list-item-content class="text-center">
                <v-progress-circular indeterminate color="blue"></v-progress-circular>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="!loading && proveedoresFiltered.length === 0">
              <v-list-item-content>
                <v-list-item-title>No hay proveedores</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProveedorCardSelect",
  props: {
    title: { type: String, default: "Seleccionar" },
    proveedorSeleccionado: { type: Object, default: null },
  },
  data() {
    return {
      proveedores: [],
      dialogProveedor: false,
      search: "",
      nextPage: 1,
      loading: false,
      pageSize: 12,
    };
  },
  computed: {
    proveedoresFiltered() {
      if (!this.search) return this.proveedores;
      const q = this.search.toLowerCase();
      return this.proveedores.filter((p) => p.nombre.toLowerCase().includes(q));
    },
  },
  methods: {
    isSelected(p) {
      return (
        this.proveedorSeleccionado &&
        this.proveedorSeleccionado.id === p.id
      );
    },
    sendProveedor(val) {
      this.$emit("set-proveedor-register", val);
      this.dialogProveedor = false;
    },
    quitarProveedor() {
      this.$emit("set-proveedor-register", null);
    },

    async loadMore() {
      if (!this.nextPage) return;
      this.loading = true;

      try {
        const params = new URLSearchParams();
        params.append("page", this.nextPage);
        params.append("page_size", this.pageSize);

        if (this.search) params.append("search", this.search);

        const res = await this.axios.get(`/proveedores/?${params}`);

        const existentes = new Set(this.proveedores.map((x) => x.id));
        const nuevos = res.data.results.filter((x) => !existentes.has(x.id));

        this.proveedores.push(...nuevos);

        if (res.data.next) {
          const url = new URL(res.data.next);
          this.nextPage = url.searchParams.get("page");
        } else {
          this.nextPage = null;
        }
      } catch (e) {
        console.error("Error cargando proveedores:", e);
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      this.proveedores = [];
      this.nextPage = 1;
      this.loadMore();
    },

    ...mapActions("proveedor", ["fetchProveedores"]),
  },

  created() {
    this.loadMore();
  },
};
</script>

<style scoped>
.hoverable-card:hover {
  background-color: rgba(25, 118, 210, 0.08);
}
</style>
